import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AcsInputComponent } from './acs-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ClickOutsideModule } from 'ng-click-outside';

@NgModule({
    declarations: [AcsInputComponent],
    exports: [AcsInputComponent],
    imports: [CommonModule, RouterModule, ClickOutsideModule, FormsModule, TranslateModule.forChild(), LocalizeRouterModule.forChild([])],
    providers: []
})
export class AcsInputModule {}
